module.exports = __webpack_public_path__ + "static/img/mobile-list2.d3ab89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-list2.png
// module id = Y3dj
// module chunks = 1